import { MODULE_NAME } from './constants';
import { widgetListProductsMapper } from './adapters';

export const moduleState = (state) => state[MODULE_NAME] || {};

export const productWidgetList = (state) => moduleState(state).data || [];

export const widgetListProducts = (state) =>
    widgetListProductsMapper(moduleState(state).products || []);
